<form #form="ngForm">
    <div *ngIf="formulaireVoyageService.paramDossierVoyage as paramFormulaireVoyage; else loading">
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.dv.parametrage'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="actif"
                            name="actif"
                            [ngModel]="paramFormulaireVoyage.actif"
                            [(customModel)]="paramFormulaireVoyage.actif"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.dv.actif"
                            postLibelle="admin.parametres.formulaire.dv.actifPost"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.dv.generalite'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isFraisAgence"
                            name="isFraisAgence"
                            [ngModel]="paramFormulaireVoyage.fraisAgence"
                            [(customModel)]="paramFormulaireVoyage.fraisAgence"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.dv.fraisAgence"
                            postLibelle="admin.parametres.formulaire.dv.fraisAgencePost"
                            [rCol]="10"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.dv.reservation'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isCommentaireAgence"
                            name="isCommentaireAgence"
                            [ngModel]="paramFormulaireVoyage.commentaireAgence"
                            [(customModel)]="paramFormulaireVoyage.commentaireAgence"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.dv.Commentaire"
                            postLibelle="admin.parametres.formulaire.dv.CommentairePost"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <floating-button [listeActions]="listeActions" [isPending]="formulaireVoyageService.isSaving"></floating-button>
    </div>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>
